/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, suffix: NonNullable<unknown>, name: NonNullable<unknown> }} Explorer_Table_Move_TextInputs */



/**
* | output |
* | --- |
* | "Move {count} item{suffix} to \"{name}\"?" |
*
* @param {Explorer_Table_Move_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_move_text = /** @type {((inputs: Explorer_Table_Move_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Move_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Deplacer ${i?.count} element${i?.suffix} vers "${i?.name}" ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Verschiebe ${i?.count} item${i?.suffix} nach "${i?.name}"?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Spostare ${i?.count} elemento${i?.suffix} in "${i?.name}"?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Переместить элемент ${i?.count}${i?.suffix} в "${i?.name}"?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Mover el elemento ${i?.count} elemento${i?.suffix} a "${i?.name}"?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`将 ${i?.count} 项目 ${i?.suffix} 移动到 "${i?.name}"？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} アイテム${i?.suffix} を "${i?.name}" に移動しますか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} आइटम${i?.suffix} को "${i?.name}" में ले जाएं?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mover o item __PH_0_ ...")
	return /** @type {LocalizedString} */ (`Move ${i?.count} item${i?.suffix} to "${i?.name}"?`)
});